import styles from './InstalmentCard.module.scss'
import { Card, Heading, Icon } from '@boltenergy-be/design-system'
import { formatCurrency } from 'utils/format.ts'
import { useTranslation } from 'react-i18next'
import { useGetLanguage } from 'hooks/use-get-language'
import EstimatedSettlement from 'components/estimated-settlement/EstimatedSettlement.tsx'
import { InstalmentCardProps } from './types'
import classNames from 'classnames'

const InstalmentCard = ({
  className,
  totalLabel,
  totalInstalment,
  electricityInstalment,
  gasInstalment,
  estimatedSettlement,
  proposedInstalment,
  loadingBillShock
}: InstalmentCardProps) => {
  // i18n
  const { t } = useTranslation(['billing', 'common'])
  const language = useGetLanguage()

  return (
    <Card className={classNames(styles['instalment-card'], className)}>
      <dl className="flex-col gap-300">
        <div className={styles.total}>
          <dt>
            <Heading as="h2">{totalLabel || t(($) => $.instalment.total)}</Heading>
          </dt>
          <dd>
            <strong>
              <data value={totalInstalment}>{formatCurrency(totalInstalment, { language })}</data>
            </strong>
          </dd>
        </div>

        {!!gasInstalment && (
          <>
            <div className={styles.entry}>
              <Icon name="electricity" />
              <dt>
                {t(($) => $.electricity, {
                  ns: 'common'
                })}
              </dt>
              <dd>
                <data value={electricityInstalment || 0}>{formatCurrency(electricityInstalment || 0, { language })}</data>
              </dd>
            </div>

            <div className={styles.entry}>
              <Icon name="gas" />
              <dt>
                {t(($) => $.gas, {
                  ns: 'common'
                })}
              </dt>
              <dd>
                <data value={gasInstalment}>{formatCurrency(gasInstalment, { language })}</data>
              </dd>
            </div>
          </>
        )}

        {(typeof loadingBillShock === 'boolean' || typeof estimatedSettlement === 'number') && (
          <EstimatedSettlement loading={!!loadingBillShock} settlementAmount={estimatedSettlement} className={styles.settlement} />
        )}

        {typeof proposedInstalment === 'number' && (
          <>
            <hr />

            <div className={styles.proposed}>
              <dt>
                <Heading as="h3">{t(($) => $.editInstalment.proposedInstalment.label)}</Heading>
                <small>{t(($) => $.editInstalment.proposedInstalment.context)}</small>
              </dt>
              <dd>
                <strong>
                  {proposedInstalment ? <data value={proposedInstalment}>{formatCurrency(proposedInstalment, { language })}</data> : '—'}
                </strong>
              </dd>
            </div>
          </>
        )}
      </dl>
    </Card>
  )
}

export default InstalmentCard
